export default __webpack_public_path__ + "static/media/img-project_1.b3e38b69.jpg";